import { FC } from 'react';

import { ParametersExceptFirst } from 'ia-react-core/~/interfaces/ParametersExceptFirst';
import { ActionMap } from 'ia-react-core/~/interfaces/ReducerActions';
import { TabsState } from 'ia-react-core/~/interfaces/TabsState';
import withSchema from 'ia-react-core/~/hocs/schema/withSchema';

import compose from '../../../utils/components/_compose';
import withUniqueId from '../../../hocs/helpers/_withUniqueId';
import injectAnalyticsScope from '../../../hocs/analytics/injectAnalyticsScope';
import injectReducer from '../../../hocs/redux/injectReducer';
import selectTabById from '../../../actions/tabs-fn/selectTabById';

import tabsReducer from './Tabs.reducer';
import ConnectedTabs from './ConnectedTabs';
import { TabsComposedProps, TabsProps } from './Tabs';

export * from './Tabs';

const ComposedTabs: FC<TabsProps> = compose<any>(
  withUniqueId('tabsId'),
  withSchema('tabs', { skip: ({ selectedTab }) => typeof selectedTab !== 'undefined' }),
  injectAnalyticsScope<TabsComposedProps>({
    key: ({ name }) => name,
  }),
  injectReducer<TabsComposedProps, TabsState>({
    key: ({ name }) => name,
    idName: 'tabsId',
    namespace: 'Core/Tab',
    skip: ({ selectedTab }) => typeof selectedTab !== 'undefined',
    identifiers: ({ tabsId, name }) => ({ tabsId, name }),
    reducer: tabsReducer,
    actions: ({ tabsId: currentModalId }) => ({
      selectTab: (...args: ParametersExceptFirst<typeof selectTabById>) => selectTabById(currentModalId, ...args),
    }) as ActionMap,
    initialState: ({ tabsId, name, initialSelectedTab }) => ({
      tabsId,
      name,
      selectedTab: (typeof initialSelectedTab !== 'undefined') ? initialSelectedTab : 0,
    }),
    useScope: true,
    createScope: false,
    cleanState: true,
  }),
)(ConnectedTabs);

export default ComposedTabs;
